import styled from "styled-components";
import { Box } from "@mui/material";

const DataGridListBox = styled(Box)`
  display: flex;
  width: 100%;

  & .actions {
    color: rgb(120, 203, 255);
  }

  & .MuiCircularProgress-root {
    color: rgb(120, 203, 255);
  }

  & .textPrimary {
    color: grey;
  }

  & .danger {
    color: rgb(246, 97, 97);
  }
`;

export default DataGridListBox;
